/**
 * BasicForm 组件注册：供 Host 动态 :is 解析。
 */
import ZipHintBasicForm from './ZipHintBasicForm.vue'
import FileGenericBasicForm from './FileGenericBasicForm.vue'
import ZipCustomBasicForm from './ZipCustomBasicForm.vue'
import SoundsBasicForm from './SoundsBasicForm.vue'
import SchemaBasicForm from './SchemaBasicForm.vue'
import AiAssistantBasicForm from './AiAssistantBasicForm.vue'
import WorkoutActionBasicForm from './WorkoutActionBasicForm.vue'
import WorkoutMusicBasicForm from './WorkoutMusicBasicForm.vue'
import WorkoutVoiceBasicForm from './WorkoutVoiceBasicForm.vue'
import WorkoutCollectionBasicForm from './WorkoutCollectionBasicForm.vue'
import BadgeBasicForm from './BadgeBasicForm.vue'
import ArticleBasicForm from './ArticleBasicForm.vue'
import StickerBasicForm from './StickerBasicForm.vue'

export const GENERIC_RESOURCE_BASIC_FORM_COMPONENTS = {
  ZipHintBasicForm,
  FileGenericBasicForm,
  ZipCustomBasicForm,
  SoundsBasicForm,
  SchemaBasicForm,
  WorkoutActionBasicForm,
  WorkoutMusicBasicForm,
  WorkoutVoiceBasicForm,
  WorkoutCollectionBasicForm,
  AiAssistantBasicForm,
  BadgeBasicForm,
  ArticleBasicForm,
  StickerBasicForm,
}

export default GENERIC_RESOURCE_BASIC_FORM_COMPONENTS
